// ds-allow-file: the brand colours feed the orb's WebGL fill, not CSS.

// The colours a bot can take: the six brand colours. Each draws as the Ask
// Opus orb with no eyes, its fill in the colour (edge: a lighter neighbour
// where Ask Opus has gold) under a slowly swirling grainy texture flecked
// with an accent (speck). Literal values: they feed the WebGL fill, not CSS.
export const AGENT_COLORS = [
  {
    slug: "orange",
    label: "Orange",
    color: "#E64919",
    edge: "#FF8A4C",
    speck: "#4a1206",
  },
  {
    slug: "amber",
    label: "Amber",
    color: "#FFBC1F",
    edge: "#FFD979",
    speck: "#3d3a1c",
  },
  {
    slug: "teal",
    label: "Teal",
    color: "#0C6E61",
    edge: "#2E9C88",
    speck: "#c6e353",
  },
  {
    slug: "aqua",
    label: "Aqua",
    color: "#6CDADA",
    edge: "#B4F2EC",
    speck: "#cfe66a",
  },
  {
    slug: "cobalt",
    label: "Cobalt",
    color: "#0D43D3",
    edge: "#3F7BF2",
    speck: "#7cc0ff",
  },
  {
    slug: "purple",
    label: "Purple",
    color: "#5F297A",
    edge: "#8C4FB5",
    speck: "#d27ae6",
  },
] as const;
